import { NgOptimizedImage } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { StudyPeriodPipe } from '@lx/quote-tool/lite/shared/ui/pipes';
import { DurationUnitEnum } from '@lx/shared/data-access/types';
import { GoogleAnalyticsClickEventDirective } from '@lx/shared/google-analytics';
import { PricePipe } from '@lx/shared/ui/pipes';
import { CourseSummary } from '../../types';

/**
 * CourseSummaryComponent - Displays a summary of the selected course
 * including course details, dates, benefits, and estimated price
 */
@Component({
  standalone: true,
  selector: 'lx-course-summary',
  templateUrl: './course-summary.component.html',
  styleUrls: ['./course-summary.component.scss'],
  imports: [NgOptimizedImage, StudyPeriodPipe, GoogleAnalyticsClickEventDirective, PricePipe],
})
export class CourseSummaryComponent {
  courseSummary = input.required<CourseSummary>();
  withEditButton = input<boolean>(false);
  gaEvent = input<string | undefined>(undefined);

  onEditClick = output<void>();

  protected readonly DurationUnitEnum = DurationUnitEnum;

  protected readonly courseName = computed(() => this.courseSummary().courseDetails?.shortName);
  protected readonly startDate = computed(() => this.courseSummary().selectedStartDate);
  protected readonly endDate = computed(() => this.courseSummary().selectedEndDate);
  protected readonly duration = computed(() => this.courseSummary().selectedDuration);
  protected readonly benefits = computed(() => this.courseSummary().courseDetails?.benefits || []);
  protected readonly grandTotal = computed(() => this.courseSummary().grandTotal);
  protected readonly currency = computed(() => this.courseSummary().currency);

  /**
   * Checks if price data is available
   * Returns true if grandTotal exists and has at least one price entry with a value
   */
  protected readonly priceAvailable = computed(() => {
    const total = this.grandTotal();
    return total !== undefined && total.length > 0 && total.some((price) => price.value !== undefined && price.value !== null);
  });
}
